export const DOCUMENT_TYPE = 'document_type';
export const FILE_TYPE = 'file_type';
export const TEXT = 'text';
export const DETECTOR_RESULTS = 'detector_results';
